import { toRefs, computed, reactive } from "vue";
import { defineStore } from "pinia";

const useErrorStore = defineStore("error", () => {
  const state = reactive({
    code: null as number | null,
    response: null as string | null,
    shouldDisplayModal: false,
    message: "",
    redirectToRoute: "",
    goHome: false,
    reloadPage: false,
    hideGenericMessage: false,
  });

  const errorCode = computed(() => state.code);
  const errorResponse = computed(() => state.response);
  const errorShouldDisplayModal = computed(() => state.shouldDisplayModal);
  const errorMessage = computed(() => state.message);
  const errorRedirectToRoute = computed(() => state.redirectToRoute);
  const errorGoHome = computed(() => state.goHome);
  const errorReloadPage = computed(() => state.reloadPage);
  const errorHideGenericMessage = computed(() => state.hideGenericMessage);

  const setError = (payload: {
    code?: number;
    response?: string;
    shouldDisplayModal?: boolean;
    message?: string;
    redirectToRoute?: string;
    goHome?: boolean;
    reloadPage?: boolean;
    hideGenericMessage?: boolean;
  }) => {
    state.code = payload.code ?? null;
    state.shouldDisplayModal = payload.shouldDisplayModal ?? true;
    state.message = payload.message ?? "";
    state.redirectToRoute = payload.redirectToRoute ?? "";
    state.response = payload.response ?? null;
    state.goHome = payload.goHome ?? false;
    state.reloadPage = typeof payload.reloadPage === "boolean" ? payload.reloadPage : false;
    state.hideGenericMessage = typeof payload.hideGenericMessage === "boolean" ? payload.hideGenericMessage : false;
  };

  const resetError = () => {
    state.code = null;
    state.shouldDisplayModal = false;
    state.message = "";
    state.redirectToRoute = "";
    state.goHome = false;
    state.reloadPage = false;
    state.hideGenericMessage = false;
  };

  return {
    ...toRefs(state),
    errorCode,
    errorGoHome,
    errorHideGenericMessage,
    errorMessage,
    errorRedirectToRoute,
    errorReloadPage,
    errorResponse,
    errorShouldDisplayModal,
    setError,
    resetError,
  };
});

export default useErrorStore;
